import { PrizeType, TablePrizeItemType } from 'entities/prize';
import { toFirstLetterUppercase } from 'shared/utils';
import { fromPrizeTypeToHumanReadableText } from 'widgets/prize/lib/helpers';
import { fromDateToHumanReadableText } from 'shared/helpers/fromDateToHumanReadableText';

export const useDefaultPrizeTableValues = (prizes: PrizeType[]): TablePrizeItemType[] => {
  if (!prizes?.length) {
    return [];
  }

  return prizes.map((prize) => ({
    id: prize?.prize_type_id,
    name: prize.name?.ru,
    type: toFirstLetterUppercase(fromPrizeTypeToHumanReadableText(prize?.category)),
    min_start_date: fromDateToHumanReadableText(prize?.min_start_date),
    max_end_date: fromDateToHumanReadableText(prize?.max_end_date),
  }));
};
